import { CHAT_TYPE } from "@/consts";
import WebIM from "@/utils/WebIM";
import { SCROLL_WARP_ID } from "@/consts";
import { LOGIN_STATUS } from '@/views/AIEditV3/consts'
/**
 *
 * state状态
 * @typedef {Object} AppState
 * @description 应用本身使用的redux state
 * @property {boolean} serverFormVisible: 新建编辑社区弹窗
 */

const App = {
  state: {
    loginStatus: LOGIN_STATUS.NONE, // V3登录态 
    isOnline: true,//在线状态
    serverFormVisible: false,
    vipRechargeModalVisible: false, //vip充值弹框
    aiRegularPopupVisible: false, //算力常规召回弹框
    vipRechargeTab: 'vip', //充值弹框默认tab: vip-会员 / power-算力
    memberLocation: 0, //会员充值入口
    isLogging: false,
    loginSuccess: false,
    selectedTab: "",
    userInfo: null, //当前用户信息
    appUserInfo: {}, //app下用户的信息
    chatMap: {
      [CHAT_TYPE.groupChat]: new Map(),
      [CHAT_TYPE.single]: new Map()
    },
    //在server下的角色
    serverRole: {},
    reactionMap: new Map(), // reaction Map
    currentChannelInfo: {},
    currentChatInfo: {}, //当前聊天对象的信息{chatType:"singleChat" "groupChat"  id:string}
    serverChannelMap: {},//server下channel映射关系及未读消息数(单独处理)
    inputDrawVisible: false, //输入框抽屉是否显示
    inputAtDrawVisible: false, //@抽屉是否显示
    quickDrawObj: {}, //快速打开绘画面板对象
    isCopyDrawMode: false, //是否复制指令绘图模式
    unReadAtDict: {}, //@未读消息字典
    unReadDict: {}, //未读消息字典
    unReadAtMsgDict: {}, //@未读消息详情字典
    limitNum: 0, //当日绘画限制次数
    currentServerFullObj: {}, //当前房间满人信息
    currentServerCanEntryObj: {}, //当前房间能否进入信息
    isFirstLoad: true, //是否是第一次加载
    ai_source: 4, //AI来源
    showGuide: false, //是否显示引导
    historyDrawingSize: "", //历史出图尺寸
    isFirstShowGuide: false, //是否是第一次显示引导
    drawPicNum: 2, //出图张数
    serverUserNumObj: {}, //当前房间人数对象
    workManageUnReadNum: 0, //工作管理未读消息数
    couponModalVisible: false, // 是否展示优惠券弹框
    appInstallPromptVisible: false, // 安装应用prompt是否展示
    drawModeValue: 1, // 绘图模式值 1-文生图 2-图生图
    // -------------------------v3--------------------------------
    isMobileDevice: false, // 是否移动端设备-ipad
  },
  reducers: {
    /**
     * @description 更新state
     * @param state: 当前state
     * @param payload: 更新state对象
     */
    updateState(state, payload) {
      return {
        ...state,
        ...payload
      };
    },
    updateUserInfo(state, payload) {
      return {
        ...state,
        ...payload
      };
    },
    // 拉取历史消息插数据
    pushMessage(state, { chatType, fromId, messageInfo, reset }) {
      let ls = [];
      if (!reset && state.chatMap[chatType].has(fromId)) {
        ls = [
          ...state.chatMap[chatType].get(fromId)?.list,
          ...messageInfo?.list
        ];
      } else {
        ls = messageInfo?.list;
      }
      return {
        ...state,
        chatMap: {
          ...state.chatMap,
          [chatType]: new Map([
            ...state.chatMap[chatType],
            ...new Map().set(fromId, {
              ...messageInfo,
              list: ls
            })
          ])
        }
      };
    },
    // 发送消息收到消息头部插入数据
    insertMessage(state, { chatType, fromId, messageInfo }) {
      let ls = [];
      const dt = state.chatMap[chatType].get(fromId);
      if (state.chatMap[chatType].has(fromId) && dt?.list) {
        let isExist = false;
        let newArr = [];
        if(messageInfo && messageInfo.list.length>0 && messageInfo.list[0].customExts && messageInfo.list[0].customExts.request_msg_id){
          dt?.list.forEach(item => {
            if (item.id === messageInfo.list[0].customExts.request_msg_id) {
              isExist = true;
              item = messageInfo.list[0];
              newArr.push(messageInfo.list[0]);
            }
            else{
              newArr.push(item);
            }
          })
        }
        if (isExist) {
          ls = [...newArr];
        }
        else{
          ls = [...messageInfo?.list, ...dt?.list];
        }
      } else {
        ls = messageInfo?.list;
      }
      setTimeout(() => {
        const $scrollWrap = document.getElementById(SCROLL_WARP_ID);
        if($scrollWrap && $scrollWrap.scrollTop > -100){
          $scrollWrap.scrollTop = $scrollWrap.scrollHeight;
        }
      }, 300);
      return {
        ...state,
        chatMap: {
          ...state.chatMap,
          [chatType]: new Map([
            ...state.chatMap[chatType],
            ...new Map().set(fromId, {
              ...dt,
              ...messageInfo,
              list: ls
            })
          ])
        }
      };
    },
    //本地发送的消息状态更新，发送成功时消息id修改为serverId
    updateChatMessageIdMid(state, { id, mid, to, status }) {
      if (to === state.currentChatInfo.id) {
        const chatType = state.currentChatInfo.chatType
        const dt = state.chatMap[chatType].get(to)
        if (state.chatMap[chatType].has(to)) {
          const ls = dt?.list || [];
          const findIndex = ls.findIndex(item => item.id === id);
          if (findIndex > -1) {
            const newMsg = { ...ls[findIndex], ...{ status, id: mid || id } }
            ls.splice(findIndex, 1, newMsg);
            return {
              ...state,
              chatMap: {
                ...state.chatMap,
                [chatType]: new Map([
                  ...state.chatMap[chatType],
                  ...new Map().set(to, {
                    ...dt,
                    list: ls
                  })
                ])
              }
            }
          }
        }
      }
      return state
    },
    //本地发送的附件消息上传成功后url更新
    changeChatMessageUrl(state, { id, to, url }) {
      if (to === state.currentChatInfo.id) {
        const chatType = state.currentChatInfo.chatType
        const dt = state.chatMap[chatType].get(to)
        if (state.chatMap[chatType].has(to)) {
          const ls = dt?.list || [];
          const findIndex = ls.findIndex(item => item.localId && item.localId === id);
          if (findIndex > -1) {
            const newMsg = { ...ls[findIndex], url }
            ls.splice(findIndex, 1, newMsg);
            return {
              ...state,
              chatMap: {
                ...state.chatMap,
                [chatType]: new Map([
                  ...state.chatMap[chatType],
                  ...new Map().set(to, {
                    ...dt,
                    list: ls
                  })
                ])
              }
            }
          }
        }
      }
      return state
    },
    //更新已读，未读
    updateUnReadNum(state, { chatType, fromId, number, message = {} }) {
      if (state.currentChatInfo.chatType === chatType && state.currentChatInfo.id === fromId) {
        if (chatType === CHAT_TYPE.single) {
          //清空未读消息
          let msg = WebIM.message.create({
            chatType: CHAT_TYPE.single,
            type: "channel",
            to: fromId
          });
          WebIM.conn.send(msg);
        }
        //当前聊天 拉取历史消息后会重置未读消息为0
        return state;
      }
      let dt = {};
      if (chatType && state.chatMap[chatType].has(fromId)) {
        dt = state.chatMap[chatType].get(fromId);
      }
      let unReadNum = number === "reset" ? 0 : dt.unReadNum && message.onlineState === 1 ? dt.unReadNum + number : number;
      if (chatType === CHAT_TYPE.groupChat) {
        //channel server 未读消息数单独处理
        const info = { ...state.serverChannelMap };
        let sId = ""
        Object.keys(info).forEach(item => {
          const channelInfo = info[item];
          if (Object.keys(channelInfo).indexOf(fromId) > -1) {
            sId = item
          }
        })
        const map = { ...state.serverChannelMap };
        map[sId][fromId] = map[sId][fromId]+unReadNum;
        state = {
          ...state,
          serverChannelMap: map
        }
        return state;
      }
      return {
        ...state,
        chatMap: {
          ...state.chatMap,
          [chatType]: new Map([
            ...state.chatMap[chatType],
            ...new Map().set(fromId, {
              ...dt,
              unReadNum
            })
          ])
        }
      };
    },
    deleteMessage(state, { chatType, fromId, id, operator }) {
      if (!chatType) {
        //其他人撤回消息
        chatType =
          fromId === WebIM.conn.user ? CHAT_TYPE.single : CHAT_TYPE.groupChat;
        if (chatType === CHAT_TYPE.single) {
          fromId = operator;
        }
      }
      const dt = state.chatMap[chatType].get(fromId);
      if (state.chatMap[chatType].has(fromId)) {
        let ls = [...state.chatMap[chatType].get(fromId)?.list];
        const idx = ls.findIndex((item) => {
          return item.id === id;
        });
        if (idx > -1) {
          const newMessage = {
            ...ls[idx],
            type: "recall",
            msg: "撤回了一条消息"
          };
          ls.splice(idx, 1, newMessage);
          return {
            ...state,
            chatMap: {
              ...state.chatMap,
              [chatType]: new Map([
                ...state.chatMap[chatType],
                ...new Map().set(fromId, {
                  ...dt,
                  list: ls
                })
              ])
            }
          };
        }
      }
      return state;
    },
    //删除未发送成功的本地消息
    deleteLocalMessage(state, { id, fromId, chatType }) {
      const dt = state.chatMap[chatType].get(fromId);
      if (state.chatMap[chatType].has(fromId)) {
        let ls = [...dt?.list];
        const idx = ls.findIndex((item) => {
          return item.id === id;
        });
        if (idx > -1) {
          ls.splice(idx, 1);
          return {
            ...state,
            chatMap: {
              ...state.chatMap,
              [chatType]: new Map([
                ...state.chatMap[chatType],
                ...new Map().set(fromId, {
                  ...dt,
                  list: ls
                })
              ])
            }
          };
        }
      }
      return state;
    },
    //更新富文本消息
    updateCustomMessage(state, { id, fromId, chatType, updateMsg }){
      const dt = state.chatMap[chatType].get(fromId);
      if (state.chatMap[chatType].has(fromId)) {
        let ls = [...dt?.list];
        const idx = ls.findIndex((item) => {
          return item.id === id;
        });
        if (idx > -1) {
          let user_message = ls[idx].customExts.user_message;
          ls[idx].customExts = {...updateMsg.customExts, user_message: user_message};
          ls[idx] = {...ls[idx]};
          return {
            ...state,
            chatMap: {
              ...state.chatMap,
              [chatType]: new Map([
                ...state.chatMap[chatType],
                ...new Map().set(fromId, {
                  ...dt,
                  list: ls
                })
              ])
            }
          };
        }
      }
      return state;
    },
    //更新channel消息的thread信息
    updateChatMessage(state, { chatType, fromId, updateInfo }) {
      const { operation, messageId } = updateInfo;
      let updateOverview = {};
      if (operation === "userRemove" || operation === "destroy") {
        updateOverview = undefined;
      } else if (operation === "create" || operation === "update") {
        updateOverview = { ...updateInfo };
      }
      if (state.chatMap[chatType].has(fromId)) {
        let ls = [...state.chatMap[chatType].get(fromId).list];
        const idx = ls.findIndex((item) => {
          return item.id === messageId;
        });
        if (idx > -1) {
          const findMessage = ls[idx];
          const info =
            findMessage.chatThreadOverview && updateOverview
              ? { ...findMessage.chatThreadOverview }
              : {};
          if (operation === "destroy") {
            findMessage.chatThreadOverview = {};
          } else if (
            operation !== "create" ||
            (operation === "create" && !info.timestamp)
          ) {
            findMessage.chatThreadOverview = { ...info, ...updateOverview };
          }
        }
        return {
          ...state,
          chatMap: {
            ...state.chatMap,
            [chatType]: new Map([
              ...state.chatMap[chatType],
              ...new Map().set(fromId, {
                ...state.chatMap[chatType].get(fromId),
                list: ls
              })
            ])
          }
        };
      }
    },
    //更新server角色
    updateServerRole(state, { serverId, role }) {
      return {
        ...state,
        serverRole: {
          ...state.serverRole,
          [serverId]: role
        }
      };
    },
    //set reaction
    updateMsgReaction(state, { msgId, reactions }) {
      return {
        ...state,
        reactionMap: new Map([
          ...state.reactionMap,
          ...new Map().set(msgId, reactions)
        ])
      };
    },
    // insert reaction
    insertReaction(state, { messageId, reaction }) {
      const { reactionMap } = state;
      const hasMsgReactions = reactionMap.has(messageId);
      const reactions = reactionMap.get(messageId) || [];
      const idx = reactions.findIndex((item) => {
        return item.reaction === reaction;
      });
      let ls = [];
      // 该消息已存在reaction
      if (hasMsgReactions) {
        if (idx > -1) {
          reactions[idx].isAddedBySelf = true;
          reactions[idx].count++;
        } else {
          reactions.push({
            count: 1,
            isAddedBySelf: true,
            reaction,
            op: [
              {
                operator: WebIM.conn.user,
                reactionType: "create"
              }
            ],
            userList: [WebIM.conn.user]
          });
        }
        ls = [...reactions];
      } else {
        ls.push({
          count: 1,
          isAddedBySelf: true,
          reaction,
          op: [
            {
              operator: WebIM.conn.user,
              reactionType: "create"
            }
          ],
          userList: [WebIM.conn.user]
        });
      }

      return {
        ...state,
        reactionMap: new Map([
          ...state.reactionMap,
          ...new Map().set(messageId, ls)
        ])
      };
    },
    // delete reaction
    deleteReaction(state, { messageId, reaction }) {
      const { reactionMap } = state;
      const reactions = reactionMap.get(messageId) || [];
      const idx = reactions.findIndex((item) => {
        return item.reaction === decodeURIComponent(reaction);
      });
      let ls = [];
      if (idx > -1) {
        reactions[idx].isAddedBySelf = false;
        reactions[idx].count--;
        if (reactions[idx].count === 0) {
          reactions.splice(idx, 1);
        }
      }
      ls = [...reactions];
      return {
        ...state,
        reactionMap: new Map([
          ...state.reactionMap,
          ...new Map().set(messageId, ls)
        ])
      };
    },
    //更新channel未读
    updateServerChannelMap(state, { serverId, channelId, unReadNum }) {
      const map = { ...state.serverChannelMap };
      if (map[serverId]) {
        map[serverId][channelId] = unReadNum;
      } else {
        map[serverId] = {
          [channelId]: unReadNum
        }
      }
      state = {
        ...state,
        serverChannelMap: map
      }
      return state;
    }
  },
  effects: (dispatch) => ({
    setLimitNum(num) {
      this.updateState({
        limitNum: num
      });
    },
    setVisible(visible) {
      this.updateState({ serverFormVisible: visible });
    },
    setVipRechargeModalVisible(visible) {
      this.updateState({ vipRechargeModalVisible: visible });
    },
    setVipRechargeTab(tab) {
      this.updateState({ vipRechargeTab: tab });
    },
    setAiRegularPopupVisible(visible) {
      this.updateState({ aiRegularPopupVisible: visible });
    },
    setMemberLocation(location) {
      this.updateState({ memberLocation: location });
    },
    setCurrentChannelInfo(channelInfo) {
      let newObj = {...channelInfo};
      if(!window.aiAbilityDict){
        window.aiAbilityDict = {};
      }
      if(!window.aiAbilityDict[channelInfo.channelId] && channelInfo.ai_ability !== undefined){
        window.aiAbilityDict[channelInfo.channelId] = {
          ai_ability : channelInfo.ai_ability,
          ai_draw: channelInfo.ai_draw,
          ai_edit_picture: channelInfo.ai_edit_picture,
          ai_train: channelInfo.ai_train,
        }
      }
      if(window.aiAbilityDict[channelInfo.channelId] && channelInfo.ai_ability === undefined){
        newObj={
          ...newObj,
          ...window.aiAbilityDict[channelInfo.channelId]
        }
      }
      this.updateState({ currentChannelInfo: newObj });
    },
    setLoginStatus(isLogging) {
      this.updateState({ isLogging });
    },
    setLoginSuccess(loginSuccess) {
      this.updateState({ loginSuccess });
    },
    setUserInfo(userInfo) {
      this.updateUserInfo({ userInfo: { ...userInfo, is_vip: userInfo?.vip_status === 1 } });
    },
    setAppUserInfo(appUserInfo) {
      // //debugger;
      this.updateState({ appUserInfo });
    },
    pushChatMessage({ fromId, messageInfo, chatType, reset }) {
      this.pushMessage({ fromId, messageInfo, chatType, reset });
    },
    insertChatMessage({ fromId, messageInfo, chatType, reset }, rootState) {
      // console.log('insertChatMessage....', fromId, messageInfo, chatType, reset)
      this.insertMessage({ fromId, messageInfo, chatType, reset });
      if (
        messageInfo.list?.length &&
        messageInfo.list[0].from !== WebIM.conn.user
      ) {
        this.updateUnReadNum({
          chatType,
          fromId,
          number: messageInfo.list.length,
          message: messageInfo.list[0]
        });
      }
      //私聊列表
      const conversationList = [...rootState.contact?.conversationList] || [];
      if (
        chatType === CHAT_TYPE.single &&
        conversationList.indexOf(fromId) < 0
      ) {
        conversationList.unshift(fromId);
        dispatch.contact.setConversationList(conversationList);
      }
    },
    updateChatThreadMessage({ chatType, fromId, updateInfo }) {
      this.updateChatMessage({ chatType, fromId, updateInfo });
    },
    setServerRole({ serverId, role }) {
      this.updateServerRole({ serverId, role });
    },
    setMsgReaction({ msgId, reactions }) {
      this.updateMsgReaction({ msgId, reactions });
    },
    insertMsgReaction({ messageId, reaction }) {
      this.insertReaction({ messageId, reaction });
    },
    setDeleteMessage({ chatType, fromId, id, operator }) {
      this.deleteMessage({ chatType, fromId, id, operator });
    },
    setCurrentChatInfo(currentChatInfo) {
      this.updateState({ currentChatInfo });
    },
    setUnReadNumber({ chatType, fromId, number }) {
      this.updateUnReadNum({ chatType, fromId, number });
    },
    setSelectedTab(selectedTab) {
      this.updateState({ selectedTab, inputDrawVisible: false });
    },
    updateChatMessageId({ id, mid, to, status }) {
      this.updateChatMessageIdMid({ id, mid, to, status })
    },
    updateChatMessageUrl({ id, to, url }) {
      this.changeChatMessageUrl({ id, to, url })
    },
    updateOnline(isOnline) {
      this.updateState({ isOnline });
    },
    deleteFailedMessage({ id, fromId, chatType }) {
      this.deleteLocalMessage({ id, fromId, chatType });
    },
    setServerChannelMap({ serverId, channelId, unReadNum }) {
      this.updateServerChannelMap({ serverId, channelId, unReadNum })
    },
    setInputDrawVisible(visible) {
      this.updateState({ inputDrawVisible: visible });
    },
    setInputAtDrawVisible(visible) {
      this.updateState({ inputAtDrawVisible: visible });
    },
    updateQuickDrawObj(obj) {
      this.updateState({ quickDrawObj: obj });
    },
    updateIsCopyDrawMode(flag) {
      this.updateState({ isCopyDrawMode: flag });
    },
    updateUnReadAtDict(obj) {
      this.updateState({ unReadAtDict: obj });
    },
    updateUnReadDict(obj) {
      this.updateState({ unReadDict: obj });
    },
    updateUnReadAtMsgDict(obj) {
      this.updateState({ unReadAtMsgDict: obj });
    },
    updateCurrentServerFullObj(obj) {
      this.updateState({ currentServerFullObj: obj });
    },
    updateCurrentServerCanEntryObj(obj){
      this.updateState({ currentServerCanEntryObj: obj });
    },
    updateFirstLoad(flag) {
      this.updateState({ isFirstLoad: flag });
    },
    updateAiSource(num) {
      this.updateState({ ai_source: num });
    },
    updateShowGuide(flag) {
      this.updateState({ showGuide: flag });
    },
    updateHistoryDrawingSize(value) {
      this.updateState({ historyDrawingSize: value });
    },
    updateIsFirstShowGuide(value) {
      this.updateState({ isFirstShowGuide: value });
    },
    updateDrawPicNum(value) {
      this.updateState({ drawPicNum: value });
    },
    updateServerUserNumObj(obj) {
      this.updateState({ serverUserNumObj: obj })
    },
    updateWorkManageUnReadNum(num) {
      this.updateState({ workManageUnReadNum: num })
    },
    updateCouponModalVisible(visible) {
      this.updateState({ couponModalVisible: visible })
    },
    updateAppInstallPromptVisible(visible) {
      this.updateState({ appInstallPromptVisible: visible })
    },
    setModalOperation(opentionName) { // 设置modal的操作名称根据名称去处理不同逻辑
      this.updateState({ modalOperation: opentionName })
    },
    setIsLykPayModalOpen(isLyk) { // 是否溜云库打开他才能
      this.updateState({ isLykPayModalOpen: isLyk })
    },
    updateDrawModeValue(num) {
      this.updateState({ drawModeValue: num })
    },
    setLoginStatue(status) { 
      this.updateState({ loginStatus: status })
    },
    setIsMobileDevice(status) { 
      this.updateState({ isMobileDevice: status })
    },
  })
};

export default App;
